import { render, staticRenderFns } from "./Waste.vue?vue&type=template&id=7fd7188e&"
import script from "./Waste.vue?vue&type=script&lang=js&"
export * from "./Waste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports